import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { message, notification } from "antd";
import {medicalExaminationService} from 'api';
import { DiagnosticExamination } from "types/models/examination-diagnostic-type";

export interface State {
    rawData?: any;
    loading: string;
    error: null;
    data?: any;
}

const initialState: State = {
    loading: 'idle',
    error: null,
}

export const getDiagnosticExamination = createAsyncThunk('diagnosticExamination/getDiagnosticExamination', async(param: any)=>{
    const response = await medicalExaminationService.getDiagnosticByIdExamination(param);
    return response.data;
})

export const diagnosticExaminationSlice = createSlice({
    name: 'getDiagnosticExamination',
    initialState: initialState,
    reducers: {

    },   
    extraReducers(builder){
        builder.addCase(getDiagnosticExamination.pending, (state, action)=>{
            if(state.loading==='idle'){
                state.loading = 'pending';
            }
        });
        builder.addCase(getDiagnosticExamination.fulfilled, (state, action)=>{
            if(state.loading === 'pending'){
                state.data = action.payload;
                state.loading = 'idle';
            }
        });
        builder.addCase(getDiagnosticExamination.rejected, (state, action)=>{
            if(state.loading === 'pending'){
                state.loading = 'idle';
            }
        })
    }
})

export const {} = diagnosticExaminationSlice.actions;
export default diagnosticExaminationSlice.reducer;